import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
} from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  CssBaseline,
  ThemeProvider,
  createTheme,
  Box,
  useMediaQuery,
} from "@mui/material";
//---------------- Styles---------------- 
// import './stylesheet.css'; // Removed - using Tailwind CDN in index.html
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.css';
import './loding.css';

//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";

//---------------- Navbar + Logout---------------- 
import HorizontalNavbar from "./HorizontalNavbar";
import MobileBottomNav from "./MobileBottomNav";
import Logout from "./Logout";

//---------------- PWA Components---------------- 
import PWAStatus from "./components/common/PWAStatus";

//---------------- Service Worker Registration---------------- 
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

//---------------- Styles---------------- 
// import './stylesheet.css'; // Removed - using Tailwind CDN in index.html
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.css';
import './loding.css';
import LodingComponent from "./loding";
// import Loginlogo from "./Loginlogo.png";

//---------------- Logo---------------- 
import BpsLogo from "./components/pages/Logo/BpsGlobal.jpeg";

//-----------SessionTimeOut---------
import SessionTimeout from "./SessionTimeout";

//-----------Company----------------
import CompanyEdit from "./components/pages/Company/Edit";

//-----------Home-------------------
import Home from "./components/pages/Home";
//-----------Role-------------------
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

//-----------User-------------------
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//-----------Product-------------------
import ProductCategoryIndex from "./components/pages/ProductCategory/Index";
import ProductItemIndex from "./components/pages/ProductItem/Index";
import ProductBrandIndex from "./components/pages/ProductBrand/Index";
import ProductRelationIndex from "./components/pages/ProductRelation/Index";

//-----------Bank-------------------
import BankIndex from "./components/pages/Bank/Index";

//-----------Master-------------------
import MasterDashboard from "./components/pages/Master/MasterDashboard";
import ClientIndex from "./components/pages/Master/ClientIndex";
import VendorIndex from "./components/pages/Master/VendorIndex";

//-----------AccountHead-------------------
import AccountHeadDashboard from "./components/pages/AccountHead/AccountHeadDashboard";
import AccountHeadIndex from "./components/pages/AccountHead/AccountHeadIndex";
import AssetIndex from "./components/pages/AccountHead/AssetIndex";
import CapitalIndex from "./components/pages/AccountHead/CapitalIndex";
import OtherOptionIndex from "./components/pages/AccountHead/OtherOptionIndex";
import BalanceSheetHeadIndex from "./components/pages/AccountHead/BalanceSheetHeadIndex";

//-----------PurchaseOrder-------------------
import PurchaseOrderIndex from "./components/pages/PurchaseOrder/PurchaseOrderIndex";

//-----------Purchase-------------------
import PurchaseIndex from "./components/pages/Purchase/PurchaseIndex";

//-----------PurchaseReturn-------------------
import PurchaseReturnAgainstIndex from "./components/pages/PurchaseReturn/PurchaseReturnAgainstIndex";

//-----------SaleReturn-------------------
import SaleReturnAgainstIndex from "./components/pages/SaleReturn/SaleReturnAgainstIndex";

//-----------Quotation-------------------
import QuotationIndex from "./components/pages/Quotation/QuotationIndex";

//-----------SalesOrder-------------------
import SalesOrderIndex from "./components/pages/SaleOrder/SalesOrderIndex";

//-----------Sale-------------------
import SaleIndex from "./components/pages/Sale/SaleIndex";
//-----------SaleReturn-------------------
// import SaleIndex from "./components/pages/Sale";

//-----------Stock-------------------
import StockTransferInIndex from "./components/pages/Stock/StockTransferInIndex";
import StockTransferOutIndex from "./components/pages/Stock/StockTransferOutIndex";

//-----------PaymentReceipts-------------------
import PaymentReceiptsIndex from "./components/pages/PaymentReceipts/PaymentReceiptsIndex";

//-----------JournalEntry-------------------
import JournalEntryIndex from "./components/pages/JournalEntry/JournalEntryIndex";

//-----------Report-------------------
import LedgerReport from "./components/pages/Report/LedgerReport";
import VendorDueListReport from "./components/pages/Report/VendorDueListReport";
import CustomerDueListReport from "./components/pages/Report/CustomerDueListReport";
import OutstandingReport from "./components/pages/Report/OutstandingReport";
import VendorAgingReport from "./components/pages/Report/VendorAgingReport";
import CustomerAgingReport from "./components/pages/Report/CustomerAgingReport";
import PurchasePartyandItemWiseReport from "./components/pages/Report/PurchasePartyandItemWiseReport";
import SalePartyandItemWiseReport from "./components/pages/Report/SalePartyandItemWiseReport";
import CashBook from "./components/pages/Report/CashBook";
import StockReport from "./components/pages/Report/StockReport";
import DetailedInvoiceReport from "./components/pages/Report/DetailedInvoice";
import IncomeExpenseSummaryReport from "./components/pages/Report/IncomeExpenseSummaryReport";

// ---------------- Theme ---------------- //
const theme = createTheme({
  // palette: {
  //   primary: { main: "#1a1f3a" },
  //   secondary: { main: "#0f1419" },
  // },
  palette: {
    primary: { main: "#4b0446ff" },
    secondary: { main: "#0f1419" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          textTransform: "none",
        },
      },
    },
  },
});

//const Sidebar = ({ open, roleName }) => {
// ---------------- Layout ---------------- //
const Layout = () => {
  const { companyName, roleName, username, isAuthenticated } = useAuth();
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Session Timeout Component - only render when authenticated */}
        {isAuthenticated && <SessionTimeout />}

        {/* PWA Status Component */}
        <PWAStatus
          showInstallPrompt={true}
          showUpdatePrompt={true}
          showOfflineStatus={true}
        />

        {/* Header with integrated menu */}
        <AppBar
          position="fixed"
          sx={{
            zIndex: (t) => t.zIndex.drawer + 1,
            background: "linear-gradient(135deg, #0f172a 0%, #4e024e 50%, #081642ff 100%)"
          }}
        >
          <Toolbar sx={{ minHeight: '48px !important', height: '48px', px: 1 }}>
            {/* BPS Logo and Company Name */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <img
                src={BpsLogo}
                alt="BPS Logo"
                style={{
                  height: '36px',
                  width: 'auto',
                  objectFit: 'contain',
                  borderRadius: '50px'
                }}
              />
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", textTransform: "uppercase" }}
              >
                <Link to="/Home" style={{ textDecoration: "none", color: "inherit" }}>
                  <span style={{ fontFamily: 'Verdana, sans-serif', fontSize: '14px' }}>{companyName}</span>
                </Link>
              </Typography>
            </Box>

            {/* Navigation Menu - Desktop only */}
            {!isMobile && username !== "Counter" && <HorizontalNavbar />}

            {/* Spacer */}
            <Box sx={{ flexGrow: 1 }} />

            {/* Logout icon only */}
            <Logout />
          </Toolbar>
        </AppBar>

        {/* Content */}
        <Box
          sx={{
            pt: '48px',
            pb: isMobile ? '70px' : 0, // Add padding for bottom nav on mobile
            minHeight: '100vh',
            backgroundColor: '#f0f4f8',
          }}
        >
          <Box sx={{ p: 0 }}>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/Home" exact component={Home} />

              {/* Role */}
              <Route path="/RoleIndex" component={RoleIndex} />
              <Route path="/RoleDetail/:id" component={RoleDetail} />

              {/* User */}
              <Route path="/UserIndex" component={UserIndex} />
              <Route path="/UserCreate" component={UserCreate} />
              <Route path="/UserEdit/:id" component={UserEdit} />
              <Route path="/UserDetail/:id" component={UserDetail} />
              <Route path="/PasswordChange" component={PasswordChange} />

              {/* Product */}
              <Route path="/ProductCategoryIndex" component={ProductCategoryIndex} />
              <Route path="/ProductItemIndex" component={ProductItemIndex} />
              <Route path="/ProductBrandIndex" component={ProductBrandIndex} />
              <Route path="/ProductRelationIndex" component={ProductRelationIndex} />

              {/* Bank */}
              <Route path="/BankIndex" component={BankIndex} />

              {/* Master */}
              <Route path="/MasterDashboard" component={MasterDashboard} />
              <Route path="/ClientIndex" component={ClientIndex} />
              <Route path="/VendorIndex" component={VendorIndex} />

              {/* AccountHead */}
              <Route path="/AccountHeadDashboard" component={AccountHeadDashboard} />
              <Route path="/AccountHeadIndex" component={AccountHeadIndex} />
              <Route path="/AssetIndex" component={AssetIndex} />
              <Route path="/CapitalIndex" component={CapitalIndex} />
              <Route path="/OtherOptionIndex" component={OtherOptionIndex} />
              <Route path="/BalanceSheetHeadIndex" component={BalanceSheetHeadIndex} />

              {/* PurchaseOrder */}
              <Route path="/PurchaseOrderIndex" component={PurchaseOrderIndex} />

              {/* Purchase */}
              <Route path="/PurchaseIndex" component={PurchaseIndex} />

              {/* PurchaseReturn */}
              <Route path="/PurchaseReturnAgainstIndex" component={PurchaseReturnAgainstIndex} />

              {/* Quotation */}
              <Route path="/QuotationIndex" component={QuotationIndex} />

              {/* SalesOrder */}
              <Route path="/SaleOrderIndex" component={SalesOrderIndex} />

              {/* Sale */}
              <Route path="/SaleIndex" component={SaleIndex} />

              {/* SaleReturn */}
              <Route path="/SaleReturnAgainstIndex" component={SaleReturnAgainstIndex} />

              {/* Stock */}
              <Route path="/StockTransferInIndex" component={StockTransferInIndex} />
              <Route path="/StockTransferOutIndex" component={StockTransferOutIndex} />

              {/* PaymentReceipts */}
              <Route path="/PaymentAndReceiptIndex" component={PaymentReceiptsIndex} />

              {/* JournalEntry */}
              <Route path="/JournalEntryIndex" component={JournalEntryIndex} />

              {/* Report */}
              <Route path="/CashBook" component={CashBook} />
              <Route path="/Ledger" component={LedgerReport} />
              <Route path="/VendorDueList" component={VendorDueListReport} />
              <Route path="/CustomerDueList" component={CustomerDueListReport} />
              <Route path="/Outstanding" component={OutstandingReport} />
              <Route path="/VendorAging" component={VendorAgingReport} />
              <Route path="/CustomerAging" component={CustomerAgingReport} />
              <Route path="/PurchasePartyandItemWiseReport" component={PurchasePartyandItemWiseReport} />
              <Route path="/SalePartyandItemWiseReport" component={SalePartyandItemWiseReport} />
              <Route path="/StockReport" component={StockReport} />
              <Route path="/DetailedInvoiceReport" component={DetailedInvoiceReport} />
              
              <Route path="/IncomeExpenseSummary" component={IncomeExpenseSummaryReport} />

              {/* Company */}
              <Route path="/CompanyEdit" component={CompanyEdit} />

            </Switch>
          </Box>
        </Box>

        {/* Mobile Bottom Navigation */}
        {isMobile && username !== "Counter" && <MobileBottomNav />}
      </Router>
    </ThemeProvider>
  );
};

// ---------------- Root ---------------- //
const App = () => {
  // Service worker disabled
  // useEffect(() => {
  //   // Register service worker with enhanced features
  //   serviceWorkerRegistration.register({
  //     onSuccess: (registration) => {
  //       console.log('SW registered successfully');
  //     },
  //     onUpdate: (registration) => {
  //       console.log('SW update available');
  //     }
  //   });

  //   // Handle PWA install prompt
  //   const handleBeforeInstallPrompt = (e) => {
  //     e.preventDefault();
  //     window.deferredPrompt = e;
  //   };

  //   const handleAppInstalled = () => {
  //     console.log('PWA was installed');
  //     window.deferredPrompt = null;
  //   };

  //   window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  //   window.addEventListener('appinstalled', handleAppInstalled);

  //   return () => {
  //     window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  //     window.removeEventListener('appinstalled', handleAppInstalled);
  //   };
  // }, []);

  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};
export default App;
